


















































































import Modal from "../core/Modals/Modal.vue";

export default {
    name: "AlertesModal",
    components: { Modal },
    props: {
        showModal: Boolean,
        // Objet `alertes` renvoyé par `MaterielApi.getStats()`.
        alertes: Object,
    },
    computed: {
        critical: function () {
            return this.alertes && this.alertes.critical
                ? this.alertes.critical
                : [];
        },
        warning: function () {
            return this.alertes && this.alertes.warning
                ? this.alertes.warning
                : [];
        },
        info: function () {
            return this.alertes && this.alertes.info ? this.alertes.info : [];
        },
        total: function () {
            return this.critical.length + this.warning.length + this.info.length;
        },
    },
    methods: {
        close: function () {
            this.$emit("close-modal");
        },
    },
};
